import angular from 'angular'

import scrapRun from './scrap.run'
import scrapRoutes from './scrap.routes'
import scrapCtrl from './scrap.controller'

const name = 'routingManeuverScrap'

angular.module(name, [

])
  .controller('scrapCtrl', scrapCtrl)
  .run(scrapRun)
  .config(scrapRoutes)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/scrap/scrap.module.js